import { useEffect, useState } from "react";

import { Input } from "#components/atoms/Input/Input";

type NameCellProps = {
  value: string;
  ariaLabel: string;
  onUpdate: (value: string) => void;
};

export const NameCell = ({ value, ariaLabel, onUpdate }: NameCellProps) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => setInputValue(value), [value]);

  return (
    <Input
      value={inputValue}
      onChange={setInputValue}
      onBlur={() => {
        if (inputValue !== value) {
          onUpdate(inputValue);
        }
      }}
      aria-label={ariaLabel}
    />
  );
};
